module.exports = __webpack_public_path__ + "img/cz-partners-CTK.e31fd816.png";